import { render, staticRenderFns } from "./packerslist.vue?vue&type=template&id=2209fa1a&"
import script from "./packerslist.vue?vue&type=script&lang=js&"
export * from "./packerslist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports